<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  classes: {
    type: String,
    default: '',
  },
});

const buttonClass = computed(() => [
  'flex items-center justify-center focus:outline-none rounded-md',
  props.classes && props.classes.length > 0 ? props.classes : 'bg-primary w-9 h-9 text-white bg-primary hover:bg-quaternary',
]);
</script>

<template>
  <button :class="buttonClass">
    <slot />
  </button>
</template>
